<template>
    <app-layout :title="'Survey: ' + surveyModel.name" :survey-layout="true">
        <survey :preview="false"
                :surveyModel="surveyModel"
                :respondentToken="respondentToken"
                :surveyResponses="surveyResponses"
                :respondent-profile="respondentProfile"
                :first-unanswered-section="firstUnansweredSection"
        />
    </app-layout>
</template>

<script>
import Survey from "@/Components/Survey";
import AppLayout from "@/Layouts/AppLayout";
export default {
    name: "Fill",
    components: {AppLayout, Survey},
    props: {
        surveyModel: {
            type: Object,
            required: true,
        },
        respondentToken: {
            type: String,
            required: true,
        },
        surveyResponses: {
            type: Object,
            required: true,
        },
        respondentProfile: {
            type: Object,
            required: true,
        },
        firstUnansweredSection: {
            type: Number,
            required: true,
        }
    }
}
</script>

<style scoped>

</style>
